import { IconProps } from './icon';
import React from 'preact/compat';

export const MinusIcon: React.FC<IconProps> = ({ title, role }) => {
  return (
    <svg
      width="10"
      height="2"
      viewBox="0 0 12 2"
      xmlns="http://www.w3.org/2000/svg"
      role={role}
    >
      {title && <title>{title}</title>}
      <path
        d="M11.25 0H.75C.3 0 0 .4 0 1s.3 1 .75 1h10.5c.45 0 .75-.4.75-1s-.3-1-.75-1z"
        fill="currentColor"
        fill-rule="nonzero"
      ></path>
    </svg>
  );
};
